import React from "react";
import "./AnnouncementBar.css";

const AnnouncementBar = () => {
  return (
    <div className="announce-bar">
      <svg className="announce-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="8" width="18" height="13" rx="1.5" />
        <path d="M12 8v13M3 12h18" />
        <path d="M12 8c-1.5 0-3-1-3-2.75A2.25 2.25 0 0 1 11.25 3c1.6 0 2.75 2 2.75 5-1.5 0-2-1-2-1z" />
        <path d="M12 8c1.5 0 3-1 3-2.75A2.25 2.25 0 0 0 12.75 3c-1.6 0-2.75 2-2.75 5 1.5 0 2-1 2-1z" />
      </svg>
      <span className="announce-text">FREE SHIPPING ON ORDERS ₹549+</span>
    </div>
  );
};

export default AnnouncementBar;
